import React from 'react'

export class MotoristaItinerario extends React.Component {

    render() {
        return (
            <tr>
                <td>
                    {this.props.motorista.label}
                </td>
                <td className='text-center' style={{ cursor: 'pointer', color: 'red' }}>
                    <div onClick={() => this.props.removerMotorista(this.props.motorista.value)}>Remover</div>
                </td>
            </tr>
        )
    }
}

export default MotoristaItinerario
